<template>
  <div class="timer">
    <div class="timer__item">{{ formatedTime }}</div>
    <span class="timer__drop">-</span>
    <div class="timer__item">{{ formatedTotalTime }}</div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'timer-index',
  data() {
    return {
      time: 0,
      intervalId: null
    }
  },

  watch: {
    currentTest() {
      this.runTimer()
    },

    time() {
      if (this.hasShowTimer && this.time === this.totalTime) {
        this.$emit('timerEnd')
      }
    }
  },

  created() {
    this.runTimer()
  },

  computed: {
    ...mapGetters({
      serverTime: 'setting/serverTime',
      currentTest: 'coursesHomeWork/currentTest',
    }),

    totalTime() {
      return this.currentTest.currentQuestion.data.responseTime
    },

    // Seconds left according to the BACKEND clock (user_questions.started_at).
    // The backend rejects answers older than response_time measured from that
    // timestamp, so the visible timer must start from the same point — not
    // from zero at render time.
    serverRemainingTime() {
      const question = this.currentTest && this.currentTest.currentUserQuestion;
      const data = question && question.data;
      const remaining = data ? data.remainingTime : null;

      return typeof remaining === 'number' ? remaining : null;
    },

    hasShowTimer() {
      return !!this.totalTime
    },

    formatedTime() {
      let minutes = Math.floor(this.time / 60);
      let seconds = this.time % 60;

      return `${minutes > 9 ? minutes : '0' + minutes} : ${seconds > 9 ? seconds : '0' + seconds}`
    },

    formatedTotalTime() {
      let minutes = Math.floor(this.totalTime / 60);
      let seconds = this.totalTime % 60;

      return `${minutes > 9 ? minutes : '0' + minutes} : ${seconds > 9 ? seconds : '0' + seconds}`
    }
  },

  beforeDestroy() {
    clearInterval(this.intervalId);
  },

  methods: {
    runTimer() {
      this.resetTime();

      // currentTest is nulled on page destroy — the watcher may still fire
      if (!this.currentTest || !this.currentTest.currentQuestion || !this.currentTest.currentQuestion.data) {
        return;
      }

      if (this.hasShowTimer && this.serverRemainingTime !== null) {
        // Start from the server-side elapsed time. If the question is already
        // expired server-side (remaining 0), time jumps to totalTime and the
        // `time` watcher fires timerEnd — the flow force-submits and moves on
        // instead of letting the student answer into a void.
        this.time = Math.min(this.totalTime, Math.max(0, this.totalTime - this.serverRemainingTime));
      }

      this.intervalId = setInterval(() => {
        if (this.time < this.totalTime) this.time = this.time + 1
      }, 1000)
    },

    resetTime() {
      clearInterval(this.intervalId);
      this.time = 0
    }
  }


};
</script>

<style scoped lang=scss>
.timer {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-size: 14px;

  &__drop {
    padding: 0 5px;
  }
}
</style>
